const intrList = [
  {
    id: 2,
    name: "FenBaWang",
    url: "粉霸王.JPG",
    Plant_type: "Medium to large size",
    Flower_color: "Pink",
    Flower_Shape: "Few-petaled",
  },
  {
    id: 3,
    name: "HongLingDieWu",
    url: "红菱蝶舞.jpg",
    Plant_type: "Medium to large size",
    Flower_color: "Dark red",
    Flower_Shape: "Double",
  },
  {
    id: 4,
    name: "ZhiZunLingXiao",
    url: "至尊凌霄.jpg",
    Plant_type: "Large size",
    Flower_color: "Dark red",
    Flower_Shape: "Double",
  },
  {
    id: 5,
    name: "DongHongHua",
    url: "冬荷.JPG",
    Plant_type: "Large size",
    Flower_color: "Red",
    Flower_Shape: "Few-petaled",
    scoure: "新引",
  },
  {
    id: 6,
    name: "JiangFuQu",
    url: "绛芙蕖.JPG",
    Plant_type: "",
    Flower_color: "Dark red",
    Flower_Shape: "Few-petaled",
  },
  {
    id: 7,
    name: "JinFuQu",
    url: "金芙蕖.png",
    Plant_type: "Medium size",
    Flower_color: "Yellow",
    Flower_Shape: "Few-petaled",
  },
  {
    id: 8,
    name: "JingHong",
    url: "惊鸿.JPG",
    Plant_type: "Large size",
    Flower_color: "Dark red",
    Flower_Shape: "Semi-double",
  },
  {
    id: 9,
    name: "QiaoShou",
    url: "翘首.JPG",
    Plant_type: "Medium to large size",
    Flower_color: "Red",
    Flower_Shape: "Double",
  },
  {
    id: 10,
    name: "QingCheng.JPG",
    url: "倾城.JPG",
    Plant_type: "Medium size",
    Flower_color: "Pink",
    Flower_Shape: "Semi-double",
  },
  {
    id: 11,
    name: "QiuHongYang.JPG",
    url: "秋红阳.JPG",
    Plant_type: "Medium to large size",
    Flower_color: "Red",
    Flower_Shape: "Double",
  },
  {
    id: 12,
    name: "QiuMuDan.JPG",
    url: "秋牡丹.JPG",
    Plant_type: "Medium to large size",
    Flower_color: "Yellow",
    Flower_Shape: "Double",
  },
  {
    id: 13,
    name: "QiuRiHongHua.JPG",
    url: "秋日红花.JPG",
    Plant_type: "Large size",
    Flower_color: "Dark red",
    Flower_Shape: "Few-petaled",
  },
  {
    id: 14,
    name: "QiuXing.JPG",
    url: "秋星.JPG",
    Plant_type: "Small to medium size",
    Flower_color: "Pink",
    Flower_Shape: "Few-petaled",
  },
  {
    id: 15,
    name: "QiuYan.JPG",
    url: "秋艳.JPG",
    Plant_type: "Medium to large size",
    Flower_color: "Red",
    Flower_Shape: "Double",
  },
  {
    id: 16,
    name: "QiuYu.jpg",
    url: "秋玉.jpg",
    Plant_type: "Medium to large size",
    Flower_color: "White",
    Flower_Shape: "Semi-double",
  },
  {
    id: 17,
    name: "SaiLingXiao.JPG",
    url: "赛凌霄.JPG",
    Plant_type: "Large size",
    Flower_color: "Dark red",
    Flower_Shape: "Double",
  },
  {
    id: 18,
    name: "ShenQiuXiangHe.jpg",
    url: "深秋香荷.jpg",
    Plant_type: "Medium to large size",
    Flower_color: "Dark red",
    Flower_Shape: "Double",
  },
  {
    id: 19,
    name: "TiDengShangYue.JPG",
    url: "提灯赏月.JPG",
    Plant_type: "Large size",
    Flower_color: "Pink",
    Flower_Shape: "Double",
  },
  {
    id: 20,
    name: "WuZhiZi2.JPG",
    url: "武植子莲2号.JPG",
    Plant_type: "Large size",
    Flower_color: "Dark red",
    Flower_Shape: "Double",
  },
  {
    id: 1,
    name: "QiuSanSe",
    url: "秋三色.png",
    Plant_type: "Large size",
    Flower_color: "Pink",
    Flower_Shape: "Double",
  },
];
export default intrList;
